import React from "react";
import Mainrouting from "./routing/Mainrouting";


const App = () => {
  return (
    <div>
      <Mainrouting/>
    </div>

  );
};

export default App;
